// modules
import { get } from 'lodash'
import { createSelector } from 'reselect'

// constants
import { NO_FACILITY_DROPDOWN_VALUE } from 'src/constants'
// utils
import { addAllValue } from 'src/utils/DataTrees'
import { addAllValue as addAllValuev5 } from 'src/utils/v5/DataTrees'

export const facilityManagement$ = (state) =>
  get(state, ['admin', 'facilityManagement'], {})

export const facilityList$ = createSelector(
  facilityManagement$,
  ({ facilityList = [] }) => facilityList
)

export const floorList$ = createSelector(
  facilityManagement$,
  ({ floorList = [] }) => floorList
)

export const roomList$ = createSelector(
  facilityManagement$,
  ({ roomList = [] }) => roomList
)

export const facilityListActiveDropdown$ = createSelector(
  facilityList$,
  (facilityList = []) =>
    facilityList
      .filter(({ isActive }) => isActive)
      .map((item) => ({
        key: item.uuid,
        title: item.name,
        isActive: item.isActive,
        value: item.uuid
      }))
)

export const facilityListDropdown$ = createSelector(
  facilityList$,
  (facilityList = []) =>
    facilityList.map((item) => ({
      key: item.uuid,
      title: item.name,
      isActive: item.isActive,
      value: item.uuid
    }))
)

export const facilityListAndNoDropdown$ = createSelector(
  facilityList$,
  (facilityList = []) => [
    ...facilityList.map((item) => ({
      key: item.uuid,
      title: item.name,
      value: item.uuid
    })),
    NO_FACILITY_DROPDOWN_VALUE
  ]
)

export const floorListDropdown$ = createSelector(floorList$, (floorList = []) =>
  floorList.map((item) => ({
    key: item.uuid,
    title: item.number,
    value: item.uuid
  }))
)

export const roomListDropdown$ = createSelector(roomList$, (roomList = []) =>
  roomList.map((item) => ({
    key: item.uuid,
    title: item.number,
    value: item.uuid
  }))
)

export const facilityListWithAll$ = createSelector(
  facilityListDropdown$,
  (facilityList = []) => addAllValue(facilityList)
)

export const facilityListWithAllvV5$ = createSelector(
  facilityListDropdown$,
  (facilityList = []) => addAllValuev5({ list: facilityList })
)

export const facilityListWithAllAndNoFacility$ = createSelector(
  facilityListDropdown$,
  (facilityList = []) =>
    addAllValue([...facilityList, NO_FACILITY_DROPDOWN_VALUE])
)

export const facilityListWithAllAndNoFacilityV5$ = createSelector(
  facilityListDropdown$,
  (facilityList = []) =>
    addAllValuev5({
      list: [...facilityList, NO_FACILITY_DROPDOWN_VALUE],
      convertList: true
    })
)

export const facilityEditValue$ = createSelector(
  facilityManagement$,
  ({ facilityEditValue = {} }) => facilityEditValue
)

export const floorEditValue$ = createSelector(
  facilityManagement$,
  ({ floorEditValue = {} }) => floorEditValue
)

export const roomEditValue$ = createSelector(
  facilityManagement$,
  ({ roomEditValue = {} }) => roomEditValue
)
